import Cookies, { CookieSetOptions } from "universal-cookie"

// No change listener: it polls document.cookie, and on iOS each read is a blocking prompt() that drops taps.
const cookies = new Cookies()

export const removeCookie = (
  cookieName: string,
  cookieOptions?: CookieSetOptions,
) => {
  cookies.remove(cookieName, cookieOptions)
}

export const getCookie = (cookieName: string) => {
  return cookies.get(cookieName)
}

export const setCookie = (
  cookieName: string,
  value: unknown,
  options: CookieSetOptions,
) => {
  return cookies.set(cookieName, value, options)
}
